import fetch from "@lib/fetch";
import { API } from "../../config";
import axios from 'axios';

export const getInvoiceByUserId = (token, id, data) => {
    return fetch(`${API}/v1/admin/financials/users/${id}`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};


export const createInvoice = (token,invoice) => {
    return fetch(`${API}/v1/invoices`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(invoice)
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
}

export const getInvoices = (token) => {
    return fetch(`${API}/v1/invoices`,{
        mode: 'cors',
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};

export const getAdminInvoices = (token) => {
    return fetch(`${API}/v1/admin/invoices`,{
        mode: 'cors',
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
}

export const getInvoiceById = (token, invoiceId) => {
    return fetch(`${API}/v1/invoices/${invoiceId}`,{
        mode: 'cors',
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};

export const uploadInvoiceImage = async (token, id, image) => {
    let data = new FormData();
    data.append('invoicePaymentImage', image);
    const res = await axios.post(`${API}/v1/invoices/${id}/payment_image`, data, {
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
        }
    });
    if(res.data.success) {
        return res.data
    } else {
        alert(res.data.message);
    }
};

export const onAdminUpdateInvoice = async (token, id, type) => {
    return fetch(`${API}/v1/admin/invoices/${id}/${type}`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
};